import { Component, OnInit, Inject, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes, UploaderOptions, UploadStatus } from 'ngx-uploader';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { FilesService } from '../../services/pcode/files/files.service';
import { PCodeServices } from '../../../../shared/services/pcode.service';

@Component({
    selector: 'pc-uploader',
    templateUrl: './upload.component.html',
    styleUrls: ["./upload.component.scss"],
    standalone: false
})
export class UploadComponent implements OnInit
{
    @ViewChild('uploader') uploaderInput: ElementRef;

    // input parameters
    @Input() url: string;
    @Input() data: any = null;
    @Input() allowedContentTypes: string[];
    @Output() uploadCompleteCallback: EventEmitter<any> = new EventEmitter();

    formData: FormData;
    files: UploadFile[];
    uploadInput: EventEmitter<UploadInput>;
    humanizeBytes: Function;
    dragOver: boolean;
    options: UploaderOptions;
    uploading: boolean = false;

    _filetypes: any;

    // upload form
    items: UntypedFormArray;
    public _form: UntypedFormGroup = this.fb.group(
        {
            items: this.fb.array([])
        }
    );

    // adding custom info
    createItem(file: UploadFile, fileName: string, fileTypeId: number): UntypedFormGroup
    {
        return this.fb.group({
            file: file,
            fileName: fileName,
            fileTypeId: fileTypeId
        });
    }

    addItem(file: UploadFile, fileName: string, fileTypeId: number): void
    {
        this.items = this._form.get('items') as UntypedFormArray;
        this.items.push(this.createItem(file, fileName, fileTypeId));
    }

    constructor(
        @Inject('BASE_URL') private baseUrl: string,
        private pcodeService: PCodeServices,
        private translateService: TranslateService,
        private filesService: FilesService,
        private fb: UntypedFormBuilder
    )
    {
    }

    ngOnInit()
    {
        this.options =
            {
                concurrency: 5,
                maxUploads: 9999,
                allowedContentTypes: this.allowedContentTypes
            };
        this.files = [];
        this.uploadInput = new EventEmitter<UploadInput>();
        this.humanizeBytes = humanizeBytes;
    }

    // call initialize to setup settings for this uploader
    initialize()
    {
        let _fileTypesFilter = this.data.FileTypesFilter || null;
        let _fileTypesObs = this.filesService.getFileTypes(_fileTypesFilter);

        forkJoin([_fileTypesObs]).subscribe(results =>
        {
            this._filetypes = results[0] as any[];
        });
    }

    onUploadOutput(output: UploadOutput): void
    {
        if (output.type === 'start' && typeof output.file !== 'undefined')
        {

        }

        if (output.type === 'allAddedToQueue')
        {
            //this.startUpload();
        }

        else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined')
        {
            this.files.push(output.file);

            const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);

            this.addItem(output.file, output.file.name, 1);
        }

        else if (output.type === 'uploading' && typeof output.file !== 'undefined')
        {
            this.uploading = true;

            const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);

            this.files[index] = output.file;
        }
        else if (output.type === 'cancelled' || output.type === 'removed')
        {
            this.files = this.files.filter((file: UploadFile) => file !== output.file);
        }
        else if (output.type === 'dragOver')
        {
            this.dragOver = true;
        }
        else if (output.type === 'dragOut')
        {
            this.dragOver = false;
        }
        else if (output.type === 'drop')
        {
            this.dragOver = false;
        }
        else if (output.type === 'rejected' && typeof output.file !== 'undefined')
        {
            this.pcodeService.notify('error', output.file.name + ':' + this.translateService.instant('Shared.Upload.Notifications.Rejected'))
            console.log(output.file.name + ' rejected');
        }

        this.files = this.files.filter(file => file.progress.status !== UploadStatus.Done);

        if (this.files.length == 0)
        {
            this.uploading = false;

            if (output.type === 'done')
            {
                this.pcodeService.notify('success', this.translateService.instant('Shared.Upload.Notifications.Success'));
                this.uploadCompleteCallback.emit();

                this.files = [];

                this.items = this._form.get('items') as UntypedFormArray;
                while (this.items.length !== 0)
                    this.items.removeAt(0)

                this.uploaderInput.nativeElement.value = '';
            }
        }
    }

    startUpload(): void
    {
        let _filesInfos = this._form.controls.items['controls'] as UntypedFormGroup[];

        this.files.forEach((_file, index) =>
        {
            let _fileInfo = _filesInfos[index];
            let _uploadBaseData =
            {
                FileName: _fileInfo.value['fileName'],
                FileTypeId: _fileInfo.value['fileTypeId']
            };

            const event: UploadInput = {
                type: 'uploadFile',
                url: this.url,
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + localStorage.getItem('access_token') },
                data: { ..._uploadBaseData, ...this.data },
                file: _file
            };

            this.uploadInput.emit(event);
        });
    }

    cancelUpload(id: string): void
    {
        this.uploadInput.emit({ type: 'cancel', id: id });
    }

    removeFile(id: string): void
    {
        this.uploadInput.emit({ type: 'remove', id: id });
    }

    removeAllFiles(): void
    {
        this.uploadInput.emit({ type: 'removeAll' });
    }
}